import { PlainResource } from '@whop/resources/types';
import { useResourceLive } from './useResourceLive';

export function useResource<T>(resource: PlainResource<T>): T {
  return useResourceLive(resource)[0];
}
